import React, { Component } from 'react';
import { Layout, Row, Col } from 'antd';
import Login from './components/login/Login';
import { Finalize, Register, Verify } from './components/register';
import { Reset, Finalize as FinalizeReset } from './components/reset';
import { Switch } from 'react-router';
import {
    Route,
  } from 'react-router-dom'
const { Content } = Layout;

export default class Auth extends Component {
    render() {
        return (
            <Layout className="layout">
                <Row type="flex" justify="space-around" align="middle">
                    <Col xs={24} sm={14} xl={8}>
                        <img src={process.env.REACT_APP_CDN_URL + '/assets/logo.png'} alt="Varma logga" width="150" style={styles.logo}/>
                        <Content>
                            <Switch>
                                <Route path='/auth/register/finalize' component={Finalize} />
                                <Route path='/auth/register/confirm' component={Verify} />
                                <Route path='/auth/reset/finalize' component={FinalizeReset} />
                                <Route path='/auth/register' component={Register} />
                                <Route path='/auth/login' component={Login} />
                                <Route path='/auth/reset' component={Reset} />
                            </Switch>
                        </Content>
                    </Col>
                </Row>
            </Layout>
        )
    }
}

const styles = {
    logo: {
        display: 'block',
        margin: '30px auto'
    }
};


// WEBPACK FOOTER //
// ./src/screens/auth/index.js